import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

import type {
  TDropdownMenuRootProps,
} from "@/ui/components/overlay/DropdownMenu/DropdownMenu.config";

export const DropdownMenuRoot = (props: TDropdownMenuRootProps) => (
  <DropdownMenuPrimitive.Root {...props} />
);

DropdownMenuRoot.displayName = DropdownMenuPrimitive.Root.displayName;
